export type MockSellingPlan = {
  id: string;
  name: string;
  description: string;
  optionValue: string;
  intervalCount: number;
  discountPercentage: number;
};

export const MOCK_MONTHLY_SELLING_PLAN: MockSellingPlan = {
  id: "gid://shopify/SellingPlan/690000000001",
  name: "Delivered every month",
  description: "Ships every month. Pause, skip or cancel any time.",
  optionValue: "1 month",
  intervalCount: 1,
  discountPercentage: 10,
};

export const MOCK_SELLING_PLANS: MockSellingPlan[] = [
  MOCK_MONTHLY_SELLING_PLAN,
  {
    id: "gid://shopify/SellingPlan/690000000002",
    name: "Delivered every 2 months",
    description: "Ships every 2 months. Pause, skip or cancel any time.",
    optionValue: "2 months",
    intervalCount: 2,
    discountPercentage: 10,
  },
];

export const findSellingPlanById = (sellingPlanId: string) => {
  return MOCK_SELLING_PLANS.find((plan) => {
    return plan.id === sellingPlanId;
  });
};

export const getSellingPlanNumericId = (sellingPlan: MockSellingPlan) => {
  return Number(sellingPlan.id.split("/").at(-1));
};

export const MOCK_SHIPPING_OPTIONS = {
  STANDARD: {
    code: "standard-shipping",
    handle: "mock-standard-shipping",
    title: "Standard Shipping",
    description: "3-5 business days",
    amount: 0,
  },
  TWO_DAY: {
    code: "two-day-shipping",
    handle: "mock-two-day-shipping",
    title: "2-Day Shipping",
    description: "2 business days",
    amount: 15,
  },
} as const;

export type MockDiscountCode = {
  code: string;
  scope: "line" | "order";
  type: "percentage" | "fixed";
  value: number;
};

const MOCK_DISCOUNT_CODES: MockDiscountCode[] = [
  /* Production's care plan code takes $5 off each unit on every line; the name is kept so `.env.example` resolves. */
  { code: "CAREPLAN-15", scope: "line", type: "fixed", value: 5 },
  { code: "SURVEY-10", scope: "order", type: "fixed", value: 10 },
  { code: "WELCOME-20", scope: "order", type: "percentage", value: 20 },
];

export const findDiscountCode = (code: string) => {
  const normalizedCode = code.trim().toUpperCase();

  return MOCK_DISCOUNT_CODES.find((discount) => {
    return discount.code === normalizedCode;
  });
};
